import { createBrowserHistory } from 'history'

const baseUrl = import.meta.env.VITE_PUBLIC_URL
const browserHistory = createBrowserHistory({ basename: baseUrl })

export { browserHistory }
